// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Sentry = require("../../reason/Sentry.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let PaymentForm__Jsx3 = require("../../uikit/reason/molecules/PaymentForm/PaymentForm__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SetAccountCardDialogMutation_graphql = require("../../__generated__/SetAccountCardDialogMutation_graphql.bs.js");

let convertVariables = SetAccountCardDialogMutation_graphql.Internal.convertVariables;

let convertResponse = SetAccountCardDialogMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SetAccountCardDialogMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SetAccountCardDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, SetAccountCardDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function SetAccountCardDialog(props) {
  let __hasExistingCard = props.hasExistingCard;
  let closeDialog = props.closeDialog;
  let hasExistingCard = __hasExistingCard !== undefined ? __hasExistingCard : true;
  let match = use();
  let mutate = match[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(PaymentForm__Jsx3.Form.make, {
        buttonText: (
          hasExistingCard ? "UPDATE" : "ADD"
        ) + ` PAYMENT CARD`,
        onToken: token => {
          let token$1 = token.id;
          return new Promise((resolve, param) => {
            mutate({
              input: {
                token: token$1
              }
            }, undefined, undefined, undefined, (param, param$1) => {
              let updatePaymentCard = param.updatePaymentCard;
              if (updatePaymentCard === undefined) {
                return resolve({
                  NAME: "PaymentError",
                  VAL: "There was a problem updating your card"
                });
              }
              if (updatePaymentCard.__typename !== "PaymentCardUpdated") {
                return resolve({
                  NAME: "PaymentError",
                  VAL: "There was a problem updating your card"
                });
              }
              resolve("Success");
              closeDialog();
            }, e => {
              Sentry.captureErrorMessage(String(e), true, undefined, "SetAccountCardDialog.res", 39, undefined, undefined, undefined);
              resolve({
                NAME: "PaymentError",
                VAL: "There was a problem updating your card"
              });
            }, undefined);
          });
        }
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
          onClick: param => closeDialog(),
          children: "Cancel"
        }),
        className: "pt-8 flex justify-center"
      })
    ],
    className: "mt-2 md:mt-4"
  });
}

let PaymentForm;

let LinkButton;

let make = SetAccountCardDialog;

exports.PaymentForm = PaymentForm;
exports.LinkButton = LinkButton;
exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
